import React from 'react'
import SIdebar from './SIdebar'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useLocation } from 'react-router-dom';


const Contato = () => {
  const location = useLocation()
    AOS.init({
      duration: 2000,
    });
    return (
      <div>
        <SIdebar local={location.pathname}/>
        <blockquote className='w3-tag w3-teal sobre' style={{padding: '20px', borderRadius: '3px'}} data-aos="fade-down">
          <h1>Principais contatos:</h1>
          <h2>EMAIL:</h2>
          <p>reinaldoper83@gmail.com</p>
          <h2>LINKEDIN:</h2>
          <a href="https://www.linkedin.com/in/reinaldo-pereira/">Linkedin</a>
          <h2>GITHUB:</h2>
          <a href="https://github.com/reinaldoper">Git hub</a>
          <br />
        </blockquote>
      </div>
    )
  
}

export default Contato;
